export const cn = {
  联系我们: '联系我们',
  '乐聊Chat++首席客户专家': '乐聊Chat++首席客户专家',
};

export const en = {
  联系我们: 'Contact Us',
  '乐聊Chat++首席客户专家': 'Chief Consultant of Chat++',
};
